import { useParams } from "react-router-dom";
import { IFormSection } from "../../types/common";
import { API_PRODUCTS } from "../../utils/apis";
import { useEffect } from "react";
export const productItemFields = [
  {
    field_name: "name",
    label: "Name",
    type: "text",
    props: { required: true },
  },

  {
    field_name: "registration_number",
    label: "Vehicle Identification Number / Chasis Number ",
    type: "text",
    props: { required: true, maxLength: 17 },
  },
  {
    field_name: "number_plate",
    label: "Number Plate",
    type: "text",
    props: { required: true },
  },
  {
    field_name: "odometer_reading",
    label: "Odometer Reading",
    type: "number",
  },
  {
    field_name: "engine_number",
    label: "Engine Number",
    type: "text",
  },
  {
    field_name: "year",
    label: "Year",
    type: "number",
  },
  {
    field_name: "color",
    label: "Color",
    type: "text",
  },
  {
    field_name: "description",
    label: "Description",
    type: "textarea",
  },
  {
    field_name: "condition",
    label: "Condition",
    type: "textarea",
  },
];
export const useProductForm = ({ form }) => {
  const sections: IFormSection[] = [
    {
      title: "Product Form",
      fields: productItemFields,
    },
  ];

  const redirect = `/products/view/${form?.id}`;

  return { sections, redirect };
};

export function submitProductForm(payload: any, id: number | null) {
  if (id) {
    return {
      id,
      api: API_PRODUCTS,
      params: payload,
    };
  }
}

export const useProductChangeStatusForm = ({ form, updateFormValue }) => {
  const { parent_id } = useParams();
  useEffect(() => {
    updateFormValue("parent_id", parent_id);
  }, [parent_id]);
  const sections: IFormSection[] = [
    {
      title: "Product Status Update Form",
      fields: [
        {
          field_name: "product_status",
          label: "Product Status",
          type: "select",
          options_data: [
            { id: "stolen", name: "Stolen" },
            { id: "impounded", name: "Impounded" },
          ],
        },
        {
          field_name: "date_of_theft",
          label: "Date of Theft",
          type: "date",
          props: { required: true },
          visible: form?.product_status === "stolen",
        },
        {
          field_name: "date_of_impoundment",
          label: "Date of Impoundment",
          type: "date",
          props: { required: true },
          visible: form?.product_status === "impounded",
        },
        {
          field_name: "condition",
          label: "Condition",
          type: "textarea",
          props: { required: true, wide: true },
          visible: form?.product_status === "impounded",
        },
      ],
    },
  ];

  const redirect = `/products/view/${parent_id}`;

  return { sections, redirect };
};

export function submitProductChangeStatusForm(payload: any, id: number | null) {
  const { parent_id } = payload;
  if (payload?.product_status === "stolen") {
    return {
      id,
      api: `/products/${parent_id}/mark-stolen/`,
      params: payload,
    };
  } else if (payload?.product_status === "impounded") {
    return {
      id,
      api: `/products/${parent_id}/impound/`,
      params: payload,
    };
  }
}
